export const ANIMATION_PRESET_UNDEFINED = 'PARTICLE_FX.ANIMATION_PRESET_UNDEFINED';
export const ANIMATION_PRESET_EMOJI = 'PARTICLE_FX.ANIMATION_PRESET_EMOJI';
export const ANIMATION_PRESET_SPARKLE = 'PARTICLE_FX.ANIMATION_PRESET_SPARKLE';
export const ANIMATION_PRESET_TELEPORT = 'PARTICLE_FX.ANIMATION_PRESET_TELEPORT';
